module.exports = __webpack_public_path__ + "img/3DScan_3.53167464.png";